// Shared price-display logic for the public showroom.
//
// A vehicle shows "Call for price" instead of a dollar amount when the dealer
// turned OFF "show price" in the CRM. The CRM feed signals this with the
// `call_for_price` flag; hidden-price units also arrive with price 0/null after
// the inventory sync, so we treat a missing/zero price as call-for-price too
// (no vehicle is legitimately sold for $0).

export function isCallForPrice(vehicle) {
  return Boolean(vehicle?.call_for_price) || !vehicle?.price;
}

// Returns the display string: "Call for price" or "$29,999".
export function formatVehiclePrice(vehicle) {
  return isCallForPrice(vehicle)
    ? 'Call for price'
    : `$${Number(vehicle.price).toLocaleString()}`;
}
